/** Environment detection — used only for UI adaptation, never for behaviour that must work everywhere. */
export function isCarBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;
  if (/tesla|qtcarbrowser/i.test(navigator.userAgent)) return true;
  // an override for a desk that wants the car's behaviour, or a car that must not have it
  try {
    const o = localStorage.getItem('rd.car');
    if (o === '1') return true;
    if (o === '0') return false;
  } catch { /* no storage */ }
  // THE TESLA STOPPED SAYING SO. Its 2026 firmware presents as a plain 'X11; Linux x86_64' Chrome 148
  // (read off Marc's car, v519): no Tesla token, so every car-only measure since v490 (the playback
  // buffer, dpr 1, stopping silent sources) silently applied to nothing. A Linux desktop with a touch
  // screen as its primary pointer is, for all practical purposes, that car.
  const linux = /X11; Linux x86_64/.test(navigator.userAgent);
  if (!linux) return false;
  const touch = navigator.maxTouchPoints > 0;
  const coarse = typeof matchMedia === 'function' && matchMedia('(pointer: coarse)').matches;
  return touch || coarse;
}

export function hasTouch(): boolean {
  if (typeof window === 'undefined') return false;
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}
